import { render, staticRenderFns } from "./collectionsInterfaceElement.vue?vue&type=template&id=ccc1118c&scoped=true&"
import script from "./collectionsInterfaceElement.vue?vue&type=script&lang=js&"
export * from "./collectionsInterfaceElement.vue?vue&type=script&lang=js&"
import style0 from "./collectionsInterfaceElement.vue?vue&type=style&index=0&id=ccc1118c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc1118c",
  null
  
)

export default component.exports